import createRoute    from '@widesk-ui/tools/createRoute';
import AdminUserModel from '@models/admin/AdminUserModel';

export default createRoute.dashboard('/admin_users', 'admin', 'AdminUserDashboard', AdminUserModel.localize());